import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Link,
  Button,
  useMediaQuery,
  useTheme,
  Divider,
  FormControl,
} from "@mui/material";
import LocalPhoneTwoToneIcon from "@mui/icons-material/LocalPhoneTwoTone";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Controller,
  FormProvider,
  SubmitHandler,
  useForm,
} from "react-hook-form";
import TextInputFieldC from "../../Components/TextInput/TextInputFieldC";
import TextAreaInputField from "../../Components/TextAreaInput/TextAreaInputField";
import { zodResolver } from "@hookform/resolvers/zod";
import { Isettingfeedback, Isupport } from "../Setting/ISetting";
import { z } from "zod";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
// import Select from "../../Components/Select/AutoComplete";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import {
  addSupport,
  clearAddSupportResponse,
} from "../../Redux/Slices/Support/AddSupportSlice";
import {
  clearListFAQ,
  listFAQ,
} from "../../Redux/Slices/Support/ListFAQSlice";
import Snackbar from "../../Components/Snackbar/Snackbar";
import {
  Select,
  MenuItem,
  InputLabel,
  // FormControl,
  FormHelperText,
} from "@mui/material";
import Menus from "../../Components/Menu/Menu";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import { useNavigate } from "react-router-dom";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
// import { Controller } from "react-hook-form";
import "./Support.scss";
import UserProfileSection from "../../Components/UserProfileSection/UserProfileSection";

const SupportSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [expanded, setExpanded] = useState(0);
  const nav = useNavigate();
  const handleChange = (panel: any) => (_: any, isExpanded: any) => {
    setExpanded(isExpanded ? panel : false);
  };

  const { data: faqResponse } = useAppSelector((state) => state.ListFAQSlice);
  const faqData = faqResponse?.data && Array.isArray(faqResponse.data) ? faqResponse.data : [];

  //   form list
  const feedbackFormRef = React.useRef<HTMLFormElement>(null);

  const userSchemafeedback = z.object({
    id: z.number().optional(),
    name: z.string({ message: "Please enter  name" }),
    email: z
      .string({
        required_error: "Please enter a valid email ID",
        message: "Please enter a valid email ID",
      })
      .email({
        message: "Please enter a valid email ID",
      }),
    issue_type: z.string({ message: "Please select issue  type" }),
    message: z.string({ message: "Please enter message" }),
  });

  // React Hook Form Methods
  const methodsfeedback = useForm<Isupport>({
    resolver: zodResolver(userSchemafeedback),
    mode: "onChange",
  });
  const dispatch = useAppDispatch();

  const handleSubmitfeedback: SubmitHandler<Isupport> = (val) => {
    dispatch(addSupport({ ...val }));
    dispatch(clearAddSupportResponse());
    methodsfeedback.reset({
      name: "",
      email: "",
      issue_type: "",
      message: "",
    });
  };

  const RoleSatus = [
    {
      label: "Billing",
      value: "billing",
    },

    {
      label: "Technical Issue",
      value: "technical_issue",
    },
    {
      label: "Content Issue",
      value: "content_issue",
    },
    {
      label: "General Feedback",
      value: "general_feedback",
    },
  ];

  const AddSettingSliceLoading = useAppSelector(
    (state) => state.AddSupportSlice
  );

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const ListUser = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];
  useEffect(() => {
    dispatch(listUser());
    dispatch(listFAQ());
  }, [dispatch]);

  return (
    <>
      {AddSettingSliceLoading?.data?.message && (
        <Snackbar response={AddSettingSliceLoading.data} />
      )}
      {/* Header */}
      {isMobile === false && (
        <div className="support_navbar_main">
          <UserProfileSection />
        </div>
      )}
      <Box p={isMobile ? 2 : "20px 22%"}>
        {/* Title */}
        <Typography
          variant="h4"
          fontWeight="bold"
          fontSize={"2.0rem"}
        // gutterBottom
        >
          Support
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body1"
          color="text.secondary"
          fontSize={"14px"}
          marginTop={"4px"}
        >
          Need help with something? Contact us or check out the common issues
          below.
        </Typography>

        {/* Highlight Box */}
        <Paper
          elevation={1}
          sx={{
            backgroundColor: "#E6F4FF",
            boxShadow: "none",
            border: "1px solid", // ✅ required for borderColor to apply
            borderColor: "#009dff33",
            padding: "11px",
            mt: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: isMobile ? "column" : "row",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <Typography sx={{ color: "#009DEF", fontSize: "14px" }}>
            Need help quickly? Call or email us anytime.
          </Typography>
          <Link
            underline="hover"
            sx={{ mt: isMobile ? 1 : 0 }}
            style={{
              fontSize: "14px",
              fontWeight: "600",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              feedbackFormRef.current?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Contact Support
          </Link>
        </Paper>

        {/* Contact Options */}
        <Typography variant="h5" fontWeight="500" mt={4} mb={2}>
          Contact Options
        </Typography>

        <Grid container spacing={2}>
          {/* Call Us */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={1}
              sx={{ p: 2, boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08)" }}
            >
              <Box display="flex" alignItems="center" mb={1} maxWidth={"150px"}>
                <LocalPhoneTwoToneIcon
                  color="primary"
                  sx={{ mr: 1, fontSize: "20px" }}
                />
                <Typography fontWeight="500" fontSize={"16px"}>
                  Call Us
                </Typography>
              </Box>
              <Typography
                variant="h6"
                color="text.secondary"
                mb={1}
                fontWeight="400"
                fontSize={"14px"}
              >
                Have urgent issues? Call us directly for live assistance.
              </Typography>
              <Typography variant="body1" fontSize={"14px"} fontWeight="600">
                +61 404 604 673
              </Typography>
            </Paper>
          </Grid>

          {/* Email */}
          <Grid item xs={12} md={6}>
            <Paper
              elevation={1}
              sx={{ p: 2, boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08)" }}
            >
              <Box display="flex" alignItems="center" mb={1} maxWidth={"150px"}>
                <MailOutlineOutlinedIcon
                  color="primary"
                  sx={{ mr: 1, fontSize: "20px" }}
                />
                <Typography fontWeight="500" fontSize={"16px"}>
                  Email
                </Typography>
              </Box>
              <Typography
                variant="h6"
                color="text.secondary"
                mb={1}
                fontWeight="400"
                fontSize={"14px"}
              >
                Send us a detailed message and we'll respond within 24 hours.
              </Typography>
              <Typography variant="body1" fontSize={"14px"} fontWeight="600">
                info@everesttutoring.com.au
              </Typography>
            </Paper>
          </Grid>
        </Grid>
        <br />
        <Box
          sx={{
            mx: "auto",
            p: isMobile ? 2 : "24px",
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08)",
            mt: 3,
          }}
        >
          <Typography
            variant="h5"
            fontWeight="500"
            sx={{
              mb: 3,
              color: "black",
              textAlign: "left",
              fontSize: isMobile ? "1.4rem" : "18px",
            }}
          >
            Submit a Support Request
          </Typography>
          <FormProvider {...methodsfeedback}>
            <form
              ref={feedbackFormRef}
              // className="form_content"
              onSubmit={methodsfeedback.handleSubmit(handleSubmitfeedback)}
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <div>
                <div className="fieldname" style={{ fontSize: "14px" }}>
                  Full Name
                </div>
                <TextInputFieldC
                  name="name"
                  sx={{
                    width: "100%",
                    marginBottom: "10px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "6px",
                    },
                    "& .MuiInputBase-input": {
                      padding: "12px 10px",
                    },
                  }}
                />
              </div>
              <div>
                <div className="fieldname" style={{ fontSize: "14px" }}>
                  Email Address
                </div>

                <TextInputFieldC
                  name="email"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "6px",
                    },
                    "& .MuiInputBase-input": {
                      padding: "12px 10px",
                    },
                  }}
                />
              </div>
              <div>
                <div className="fieldname" style={{ fontSize: "14px" }}>
                  Issue Type
                </div>

                <Controller
                  name="issue_type"
                  control={methodsfeedback.control}
                  render={({ field, fieldState }) => (
                    <FormControl
                      fullWidth
                      error={!!fieldState.error}
                      sx={{
                        marginBottom: "16px",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "6px",
                        },
                        "& .MuiInputBase-input": {
                          padding: "12px 10px",
                        },
                      }}
                    >
                      {/* <InputLabel id="issue-type-label">Select an Issue</InputLabel> */}
                      <Select
                        labelId="issue-type-label"
                        // placeholder="Select an Issue"
                        displayEmpty
                        {...field}
                        // label="Issue Type"
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <span style={{ color: "#64748b" }}>
                                Select an Issue
                              </span>
                            );
                          }
                          return RoleSatus.find(
                            (option) => option.value === selected
                          )?.label;
                        }}
                      >
                        {RoleSatus.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      {fieldState.error && (
                        <FormHelperText>
                          {fieldState.error.message}
                        </FormHelperText>
                      )}
                    </FormControl>
                  )}
                />
              </div>
              <div>
                <div className="fieldname" style={{ fontSize: "14px" }}>
                  Message
                </div>
                <TextAreaInputField
                  name="message"
                  placeholder="Describe your issue or question in detail..."
                  rows={4}
                  sx={{
                    width: "100%",
                    marginBottom: "20px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "6px",
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#64748b",
                      opacity: 1,
                    },
                  }}
                />
              </div>

              <Button
                onClick={() => feedbackFormRef.current?.requestSubmit()}
                variant="contained"
                sx={{
                  alignSelf: isMobile ? "stretch" : "flex-start",
                  backgroundColor: "#009DFF",
                  color: "#fff",
                  textTransform: "none",
                  fontWeight: "600",
                  fontSize: "15px",
                  "&:hover": {
                    backgroundColor: "#009DFF",
                  },
                }}
              >
                Submit Request
              </Button>
            </form>
          </FormProvider>
        </Box>
        <br />
        <Box
          sx={{
            mx: "auto",
            p: isMobile ? 2 : 4,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.08)",
            mt: 3,
          }}
        >
          <Typography
            variant="h5"
            fontWeight="600"
            sx={{
              mb: 3,
              color: "black",
              textAlign: "left",
              fontSize: isMobile ? "1.4rem" : "18px",
            }}
          >
            Frequently Asked Questions
          </Typography>

          <Box sx={{ mt: 3 }}>
            {faqData.map((faq, index) => (
              <>
                <Accordion
                  key={index}
                  expanded={expanded === index}
                  onChange={handleChange(index)}
                  disableGutters
                  elevation={0}
                  sx={{
                    "&:before": {
                      display: "none",
                    },
                    border: "none",
                    boxShadow: "none",
                    mb: index === faqData.length - 1 ? 0 : 0.5,
                    "&:hover": {
                      color: "#009dff",
                      "& .MuiSvgIcon-root": {
                        color: "#009dff",
                      },
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      minHeight: 56,
                      px: 0,
                      py: 0,
                      "&.Mui-expanded": {
                        minHeight: 56,
                      },
                      "& .MuiAccordionSummary-content": {
                        my: 0,
                        py: 0,
                        margin: 0,
                      },
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight="500"
                      fontSize={"14px"}
                      sx={{
                        flexShrink: 0,
                      }}
                    >
                      {faq.question}
                    </Typography>
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      padding: "0px 0px 16px",
                      //   borderBottom:
                      //     index !== faqData.length - 1
                      //       ? `1px solid ${theme.palette.divider}`
                      //       : "none",
                    }}
                  >
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      fontSize={"14px"}
                    >
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                <Divider sx={{ borderColor: "divider" }} />
              </>
            ))}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SupportSection;
